import React from 'react';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/** 에듀코디형: 변경된 데이터가 있을 때 닫기 확인 */
const UnsavedCloseConfirm: React.FC<Props> = ({ open, onCancel, onConfirm }) => {
  if (!open) return null;

  return (
    <div className="cp-pin-confirm-overlay" role="presentation" onClick={onCancel}>
      <div
        className="cp-pin-confirm cp-pin-confirm--warn"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-pin-unsaved-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cp-pin-confirm-warn-icon" aria-hidden>
          !
        </div>
        <p id="cp-pin-unsaved-title" className="cp-pin-confirm-warn-title">
          변경된 데이터가 있습니다.
        </p>
        <p className="cp-pin-confirm-warn-desc">팝업을 닫으시겠습니까?</p>
        <div className="cp-pin-confirm-actions cp-pin-confirm-actions--split">
          <button
            type="button"
            className="cp-pin-modal-btn cp-pin-modal-btn--secondary"
            onClick={onCancel}
          >
            취소
          </button>
          <button
            type="button"
            className="cp-pin-modal-btn cp-pin-modal-btn--primary"
            onClick={onConfirm}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedCloseConfirm;
